































































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

import { hide } from '@/directives/hide';
import { getCurrencySymbol } from '@/utils/currency';
import { roundCurrency } from '@/utils/helpers';

export default mixins(Proxyable).extend({
  name: 'QuoteDiscountPercentTextField',

  props: {
    total: { type: Number, required: true },
    exchangeRate: Number,
    currencyCode: String
  },

  directives: {
    hide
  },

  data: () => ({
    displayDiscountAsDollarAmount: false,
    internalDollarAmount: '0',
    error: false
  }),

  computed: {
    valueRules(): ((v: number) => boolean)[] {
      return [
        (v: number) => v < this.total || false,
        (v: number) => v >= 0 || false
      ];
    },

    percentRules(): ((v: number) => boolean)[] {
      return [(v: number) => v <= 100 || false, (v: number) => v >= 0 || false];
    }
  },

  methods: {
    getCurrencySymbol,

    calculateAmountDiscount(): number {
      if (this.total <= 0) return 0;
      return roundCurrency(
        ((Number(this.internalValue) * this.total) / 100) * 1.0
      );
    },

    onSwitchChangeHandler(showAsDollarAmount: boolean) {
      if (showAsDollarAmount) {
        this.internalDollarAmount = this.calculateAmountDiscount().toFixed(2);
      }
    },

    percentageErrorHandler(err: boolean) {
      if (err) {
        this.error = err;

        // Setting value to limits if user enters invalid data
        if (Number(this.internalValue) > 100) {
          this.internalValue = 100;
        } else if (Number(this.internalValue) < 0) {
          this.internalValue = 0;
        } else {
          this.internalValue = 0;
        }

        //ensures that component displays 2 decimals places
        this.internalValue = Number(this.internalValue).toFixed(2);
      }
    },

    percentageInputHandler(percentage: string) {
      if (this.error) {
        this.error = false;
      }
    }
  }
});
